<template>
  <v-dialog v-model="dialog" persistent @keydown.esc="close()" max-width="500px">
    <v-form ref="formRegistra">
      <v-card>
        <v-card-text>
          <v-container grid-list-xl>
            <v-col>
              <v-flex>
                <v-alert :value="!!alertElaborazione" type="warning" transition="scale-transition">{{ alertElaborazione
                  }}</v-alert>
              </v-flex>
              <v-flex pb-0>
                <v-text-field label="Utente" v-model="editedItem.Utente" required :rules="[
    () => !!editedItem.Utente > 0 || 'Il campo è obbligatorio',
  ]"></v-text-field>
              </v-flex>
              <v-flex pb-0>
                <v-text-field label="Password" v-model="editedItem.Password" :type="'password'"></v-text-field>
              </v-flex>
              <v-flex pb-0>
                <v-select label="Tipologia" v-model="editedItem.Tipologia" required :rules="[
    () =>
      !!editedItem.Tipologia > 0 || 'Il campo è obbligatorio',
  ]" :items="tipologie"></v-select>
              </v-flex>
              <v-flex pb-0>
                <v-row class="ml-0 pl-0 mr-0 pr-0">
                  <v-text-field label="Codice" v-model="editedItem.Codice" required :rules="[
    () =>
      !!editedItem.Codice > 0 || 'Il campo è obbligatorio',
  ]" class="mr-2"></v-text-field>
                  <v-text-field v-if="editedItem.Tipologia &&
    editedItem.Tipologia.toLowerCase().includes('agente')
    " label="Obiettivo annuale" v-model="editedItem.Obiettivo" required type="number" prefix="€"
                    class="ml-2"></v-text-field>
                </v-row>
              </v-flex>
              <v-flex pb-0>
                <v-text-field label="E-mail" v-model="editedItem.EMail"></v-text-field>
              </v-flex>
              <v-flex pb-0>
                <v-switch label="Account attivo" v-model="editedItem.AccountAttivo" class="pa-0"></v-switch>
              </v-flex>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" text icon @click.native="elimina()">
            <v-icon medium>delete</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="close">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click.native="save">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { get_listaRoles } from "@/api/api.admin.js";

export default {
  props: {
    editedItem: null,
    dialog: { type: Boolean, default: false },
    alertElaborazione: { type: String, default: "" },
  },
  data: () => ({
    tipologie: [],
  }),

  methods: {
    caricaDati() {
      get_listaRoles()
        .then((res) => {
          //console.log(res.data);

          this.tipologie = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    close() {
      this.$emit("close");
    },

    save() {
      // Validazione
      if (this.$refs.formRegistra.validate() == false) {
        return;
      }

      // Conferma
      this.$root.$confirm("Salva", "Vuoi salvare i dati ?").then((confirm) => {
        if (!confirm) return;

        this.$emit("save");
      });
    },
    elimina() {
      this.$emit("elimina");
    },
  },

  watch: {
    dialog(val) {
      if (val) {
        // NOTA: sul nuovo inserimento resetto la validazione
        //       (altrimenti i campi verrebberò validati)
        if (this.editedItem.IdUtente == 0) { //this.$refs.formRegistra.reset();
          this.$nextTick(() => this.$refs.formRegistra.resetValidation());
        }

        this.caricaDati();
      }
    },
  },
};
</script>
